import styled from 'styled-components';
import {
  carGradient,
  electricityGradient,
  heatingGradient,
  solarGradient,
  white,
} from '../theme/colors';

const GraphTooltip = styled.div`
  width: 165px;
  height: 65px;
  padding: 7px 1px 7px 7px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.3);
  background-color: ${white};
  display: block;
  opacity: 0;
  position: absolute;
  font-size: 10px;

  .title {
    display: block;
    color: white;
    font-weight: 800;
    padding: 3px 5px 2px;
    margin-right: 5px;
    margin-bottom: 2px;
    border-radius: 2px;
  }

  i {
    width: 8px;
    height: 8px;
    display: inline-block;
    background: black;
    border-radius: 50%;
    margin-top: 3px;
    margin-right: 3px;
  }

  .elec {
    .title {
      background-image: ${electricityGradient};
    }

    i {
      background-image: ${electricityGradient};

      &.now {
        opacity: 0.5;
      }
    }
  }

  .heat {
    .title {
      background-image: ${heatingGradient};
    }

    i {
      background-image: ${heatingGradient};

      &.now {
        opacity: 0.5;
      }
    }
  }

  .car {
    .title {
      background-image: ${carGradient};
    }

    i {
      background-image: ${carGradient};

      &.now {
        opacity: 0.5;
      }
    }
  }

  .solar {
    .title {
      background-image: ${solarGradient};
    }

    i {
      background-image: ${solarGradient};

      &.now {
        opacity: 0.5;
      }
    }
  }
`;

export default GraphTooltip;
